<template>
  <div class="book-nav">
    <div class="book-nav__scroll">
      <router-link
        v-for="(item, idx) in items"
        :key="idx"
        :to="item.to"
        class="book-nav__item"
        active-class="active"
      >
        <span class="book-nav__text" v-html="$t('kps.sectionShort', { n: item.n })"></span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookSectionNavigation",
  data() {
    return {
      items: [
        { n: 1,  to: '/kps/map' },
        { n: 2,  to: '/kps/personnel' },
        { n: 3,  to: '/kps/orders' },
        { n: 4,  to: '/kps/section-4' },
        { n: 5,  to: '/kps/section-5' },
        { n: 6,  to: '/kps/section-6' },
        { n: 7,  to: '/kps/officers-work' },
        { n: 8,  to: '/kps/inspections' },
        { n: 9,  to: '/kps/dd-members' },
        { n: 10, to: '/kps/plan-extract' },
        { n: 11, to: '/kps/border-violations' },
        { n: 12, to: '/kps/regime-violations' },
        { n: 13, to: '/kps/border-regime-violations' },
        { n: 14, to: '/kps/guard-rules-violations' },
      ]
    };
  }
};
</script>

<style scoped>
.book-nav {
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid #E9EAEC;
  padding: 1rem 2rem 0 2rem; /* padding top/sides */
  box-sizing: border-box;
  overflow: hidden;
}

.book-nav__scroll {
  display: flex;
  width: 100%;
  overflow-x: auto;
  gap: 0;
  padding-bottom: 1px; /* To show borber bottom if needed */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.book-nav__scroll::-webkit-scrollbar {
  display: none;
}

.book-nav__item {
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px 14px;
  min-width: 0;
  text-decoration: none;
  border: 1px solid #E9EAEC;
  border-right: none;
  background: #fff;
  color: #111827;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
  height: 52px;
  box-sizing: border-box;
}

.book-nav__item:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 0px; /* Tab style usually flat bottom or attached */
}
.book-nav__item:last-child {
  border-right: 1px solid #E9EAEC;
  border-top-right-radius: 6px;
}

.book-nav__item:hover {
  background: #f9fafb;
}

.book-nav__item.active {
  border: 2px solid #3B82F6;
  border-bottom: 2px solid #3B82F6; /* Or maybe transparent bottom if it connects to content? */
  /* Screenshot shows blue border box for selected item */
  background: #fff;
  color: #3B82F6;
  font-weight: 700;
  z-index: 1; /* overlap neighbors */
  position: relative;
}
</style>
